import React from 'react';
import { BaseHistoryEntryData, PersonData } from 'nekst-api';
import RecordLayout, { RecordLayoutProps } from './RecordLayout';
import PersonLink from './PersonLink';
import { HistoryEventIconType } from './HistoryEventIcon';

interface ClientPortalInvitationSentData extends BaseHistoryEntryData {
  contact: PersonData;
}

export default function ClientPortalInvitationSentRecordLayout(
  props: RecordLayoutProps<ClientPortalInvitationSentData>,
) {
  return (
    <RecordLayout
      text={(
        <>
          {'Client Portal was shared with '}
          <PersonLink person={props.record.data.contact} />
          {' by '}
          <PersonLink person={props.record.data.person!} />
          .
        </>
      )}
      date={props.record.when}
      iconType={HistoryEventIconType.PORTAL_INVITATION_SENT}
    />
  );
}
